import { 
  EpDevPApiClient 
} from '../EpDevPApiClient';
import {
  IEpDevPDomainsApiClient,
  IEpDevPListDomainsResponse,
} from '../types';
import { EpDevPDomainsApiPathsFactory } from './EpDevPDomainsApiFactories';


export class EpDevPDomainsApiClient extends EpDevPApiClient implements IEpDevPDomainsApiClient {

  public async list({ organizationId }:{
    organizationId: string;
  }): Promise<IEpDevPListDomainsResponse> {
    const epDevPListDomainsResponse: IEpDevPListDomainsResponse = await this.request({
      method: 'GET',
      url: await this.createUrl(EpDevPDomainsApiPathsFactory.createListPath({ 
        organizationId: organizationId, 
      }))
    });
    return epDevPListDomainsResponse;
  }

}
